const iframe = () => {
  const ifameSrc =
      'https://demo.evoplay.games/demo/fullstate/html5/evoplay/anubismoon',
    play = document.querySelector('#btn_iframe'),
    bg = document.querySelector('.iframe_bg'),
    iframe = document.querySelector('#iframe'),
    start = document.querySelectorAll('.start_game');
  play.addEventListener('click', () => {
    gameStart();
  });
  start.forEach(item => {
    item.addEventListener('click', () => {
      gameStart();
    });
  });
  function gameStart() {
    console.log(11);
    iframe.src = ifameSrc;
    bg.classList.add('hidden');
    play.classList.add('hidden');
    iframe.classList.add('visible');
  }
};
export default iframe;
